module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"tab":{"all":"全レビュー","video":"ビデオ·レビュー"}}}')
  delete Component.options._Ctor
}
